import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = { class: "flex space-x-3 mb-5" }
const _hoisted_5 = { class: "w-12 h-12 rounded-full bg-gray-200 flex justify-center items-center flex-shrink-0" }
const _hoisted_6 = { class: "w-full text-left" }
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = { class: "mt-6 flex space-x-2 justify-end" }

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'
import ButtonComponent from '@/components/ButtonComponent.vue';
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    width: {
        type: String,
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: __props.show,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
        class: "relative z-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.width, "transform overflow-hidden rounded-lg bg-white py-5 px-7 align-middle transition-all"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(ExclamationCircleIcon), { class: "w-5 h-5 text-gray-900 mx-auto" })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(DialogTitle), {
                            as: "p",
                            class: "font-bold text-lg text-gray-900"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.title), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.content), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _renderSlot(_ctx.$slots, "fields")
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        (__props.cancelText)
                          ? (_openBlock(), _createBlock(ButtonComponent, {
                              key: 0,
                              secondary: "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
                              text: __props.cancelText
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.cancelText), 1)
                              ]),
                              _: 1
                            }, 8, ["text"]))
                          : _createCommentVNode("", true),
                        (__props.actionText)
                          ? (_openBlock(), _createBlock(ButtonComponent, {
                              key: 1,
                              color: "bg-gray-900 border-gray-900",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
                              text: __props.actionText
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.actionText), 1)
                              ]),
                              _: 1
                            }, 8, ["text"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})